/**
 * @generated SignedSource<<f47b6341289ce24a68341e13ee18f7be>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FeatureKey = "ADDITIONAL_LISTS" | "BIOMETRIC_LOCK" | "BUDGET" | "ESTATE_SEARCH" | "EXTENDED_ADDRESS_LOOKUP" | "FLOOD_MAP" | "HOME_FEED" | "HOME_OWNERSHIP" | "HOME_RECORDS" | "HOME_UPDATES" | "HOME_UPDATES_PUSH_ANNIVERSARY" | "HOME_UPDATES_PUSH_FLOOD" | "HOME_UPDATES_PUSH_HOME_VALUE" | "HOME_UPDATES_PUSH_PLANNING" | "HOME_UPDATES_PUSH_RATE_DECISION" | "HOME_UPDATES_PUSH_RENT_CHECK" | "HOME_UPDATES_PUSH_SOLD_NEAR_YOU" | "HOUSEHOLD_MONEY" | "JOURNEY_NUDGES" | "LISTING_PHOTO_IMPORT" | "LOCAL_KNOWLEDGE" | "NOISE_INSIGHT" | "PERSONA_JOURNEYS" | "REACHABLE_AREA_SCENE" | "REALTIME_PRESENCE" | "REAL_JOURNEY_TIMES" | "REMOTE_FETCH_IMPORT" | "VIEWINGS" | "VIEWING_NOTE_SUGGESTIONS" | "VOICE" | "%future added value";
export type ExperimentVariantInput = {
  name: string;
  weight: number;
};
export type experimentMutationsDefineMutation$variables = {
  flagKey: FeatureKey;
  key: string;
  variants: ReadonlyArray<ExperimentVariantInput>;
};
export type experimentMutationsDefineMutation$data = {
  readonly defineExperiment: {
    readonly flagKey: FeatureKey;
    readonly key: string;
    readonly variants: ReadonlyArray<{
      readonly name: string;
      readonly weight: number;
    }>;
  };
};
export type experimentMutationsDefineMutation = {
  response: experimentMutationsDefineMutation$data;
  variables: experimentMutationsDefineMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "flagKey"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "variants"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "flagKey",
        "variableName": "flagKey"
      },
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "key"
      },
      {
        "kind": "Variable",
        "name": "variants",
        "variableName": "variants"
      }
    ],
    "concreteType": "ExperimentState",
    "kind": "LinkedField",
    "name": "defineExperiment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "flagKey",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ExperimentVariantState",
        "kind": "LinkedField",
        "name": "variants",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "weight",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "experimentMutationsDefineMutation",
    "selections": (v3/*: any*/),
    "type": "FeatureToggleMutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "experimentMutationsDefineMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "a909c63dc21cbdeedbdae36ffa1d6038",
    "id": null,
    "metadata": {},
    "name": "experimentMutationsDefineMutation",
    "operationKind": "mutation",
    "text": "mutation experimentMutationsDefineMutation(\n  $key: String!\n  $flagKey: FeatureKey!\n  $variants: [ExperimentVariantInput!]!\n) {\n  defineExperiment(key: $key, flagKey: $flagKey, variants: $variants) {\n    key\n    flagKey\n    variants {\n      name\n      weight\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "205afa5f5eb5603d03fbaf07706daeea";

export default node;
